import { msg } from '@lingui/core/macro';

import { defineEntitySource } from '@/shared/form/entity-source';
import { getCurrentTenant } from '@/shared/http/client';

import type { BillingSettingOption } from './billing-setting.wire';

// Porta de busca de régua de cobrança (F0, discovery/10 §4) para os outros módulos: Cessionário,
// Recuperação de crédito (Formalizar) e Nova cobrança. Leve: o fio vem por import dinâmico.

const api = () => import('./billing-setting.api');

/** "(código) - nome", o rótulo do autocomplete do legado (billingParametersContext.tsx:71-74). */
export const billingSettingSource = defineEntitySource<BillingSettingOption>({
  key: ['billing-setting', 'options'],
  scope: () => getCurrentTenant() ?? null,
  search: async (query, signal) =>
    (
      await (
        await api()
      ).listBillingSettingOptions(
        { searchString: query || undefined, tenant: getCurrentTenant() },
        signal,
      )
    ).data,
  byId: async (id, signal) => (await api()).getBillingSetting(id, signal),
  toOption: (item, i18n) => ({
    value: item.id,
    label: `(${String(item.walletCode ?? '')}) - ${item.name ?? i18n._(msg`Sem nome`)}`,
  }),
});

export function billingSettingSourceForWallet(
  walletsCode: () => string | number | null | undefined,
) {
  return defineEntitySource<BillingSettingOption>({
    ...billingSettingSource,
    scope: () => [getCurrentTenant() ?? null, walletsCode() ?? null],
    search: async (query, signal) =>
      (
        await (
          await api()
        ).listBillingSettingOptions(
          {
            walletsCode: walletsCode(),
            searchString: query || undefined,
            tenant: getCurrentTenant(),
          },
          signal,
        )
      ).data,
  });
}
